import { useLanguage } from '../../../contexts/LanguageContext';
import RegisterLink from '../../../components/RegisterLink';
import promoBattleOfRiches from '../../../assets/promo-battle-of-riches.png';

export default function PromoBanner() {
  const { t } = useLanguage();

  return (
    <section
      className="py-10"
      style={{ background: 'linear-gradient(135deg, #0d0101 0%, #180303 50%, #0d0101 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="relative rounded-2xl overflow-hidden"
          style={{ border: '1px solid rgba(212,160,23,0.3)' }}
        >
          <div className="absolute inset-0 opacity-20"
            style={{ background: 'linear-gradient(135deg, #cc1100, transparent 50%, #d4a017)' }} />
          <div className="relative grid md:grid-cols-[1.25fr_1fr] items-stretch">
            <RegisterLink source="promo_banner_image" className="block cursor-pointer">
              <img
                src={promoBattleOfRiches}
                alt={t('Battle of Riches game promotion', 'Promosi permainan Battle of Riches')}
                className="w-full h-52 md:h-full object-cover object-center"
              />
            </RegisterLink>

            <div className="p-5 md:p-7 flex flex-col justify-center gap-3 md:gap-4">
              <p className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
                {t('Featured Slot Promotion', 'Promosi Slot Pilihan')}
              </p>
              <h3 className="text-white text-xl md:text-2xl font-black leading-tight">
                {t('Battle of Riches Is Live', 'Battle of Riches Kini Dibuka')}
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                {t(
                  'Spin the latest MegaH5 hit for big rewards and fast withdrawals. Limited-time event, join now.',
                  'Main permainan terbaru MegaH5 untuk ganjaran besar dan pengeluaran pantas. Acara masa terhad, sertai sekarang.'
                )}
              </p>
              <RegisterLink
                source="promo_banner_play_now"
                label={t('Play Now', 'Main Sekarang')}
                className="inline-flex items-center gap-2 font-bold px-5 py-2.5 rounded-lg hover:opacity-90 transition-opacity text-sm w-fit"
                style={{ background: 'linear-gradient(135deg, #cc1100, #ff2200)', color: 'white' }}
              >
                <span>{t('Play Now', 'Main Sekarang')}</span>
                <i className="ri-arrow-right-line" />
              </RegisterLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
